import { PATH } from 'shared/constants';

export const eventSelectLanguage = (language, name) => ({
  eventName: 'event_selectlanguage',
  screen_name: PATH.WELCOME,
  language,
  name
});

export const eventSkipClick = (language, name) => ({
  eventName: 'event_skipclick',
  screen_name: PATH.WELCOME,
  language,
  name
});

export const eventLetsStartClick = (language, name) => ({
  eventName: 'event_letsstartclick',
  screen_name: PATH.WELCOME,
  name,
  language
});

export const eventCallUs = (language) => ({
  eventName: 'event_callus',
  screen_name: PATH.HOME,
  language
});

export const eventStartInvestmentAdvice = (language, name) => ({
  eventName: 'event_startinvestmentadvice',
  screen_name: PATH.HOME,
  language,
  name
});

export const eventResumeInvestmentAdvice = (language, name) => ({
  eventName: 'event_resumeinvestmentadvice',
  screen_name: PATH.HOME,
  language,
  name
});

export const eventInvestmentProfileStartNow = (language, name) => ({
  eventName: 'event_investmentprofile_startnow',
  screen_name: PATH.JOURNEY_OVERVIEW,
  language,
  name
});

export const eventInvestmentProfileAge = (language, name, age) => ({
  eventName: 'event_investmentprofile_age',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age
});

export const eventInvestmentProfileInitialCapital = (language, name, age, initial_capital) => ({
  eventName: 'event_investmentprofile_initialcapital',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age,
  initial_capital
});

export const eventGetInTouchEmail = (language) => ({
  eventName: 'event_getintouch_email',
  screen_name: PATH.CALL_TO_ACTION,
  language
});

export const eventGetInTouchOpenAccount = (language) => ({
  eventName: 'event_getintouch_openaccount',
  screen_name: PATH.CALL_TO_ACTION,
  language
});

export const eventGetInTouchMeetAdvisor = (language) => ({
  eventName: 'event_getintouch_meetadvisor',
  screen_name: PATH.CALL_TO_ACTION,
  language
});

export const eventGetInTouchCompleted = (language, name) => ({
  eventName: 'event_getintouch_completed',
  screen_name: PATH.THANK_YOU,
  language,
  name
});

export const eventLearnMore = (language, name) => ({
  eventName: 'event_learnmore',
  screen_name: PATH.HOME,
  language,
  name
});

export const eventInvestmentProfileName = (language, name) => ({
  eventName: 'event_investmentprofile_name',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name
});

export const eventInvestmentProfileGoal = (language, name, age, financial_goal) => ({
  eventName: 'event_investmentprofile_goal',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age,
  financial_goal
});

export const eventInvestmentProfileTargetAmount = (language, name, age, financial_goal, target_amount) => ({
  eventName: 'event_investmentprofile_targetamount',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age,
  financial_goal,
  target_amount
});

export const eventInvestmentProfileGoalYears = (language, name, age, financial_goal, target_amount, goal_years) => ({
  eventName: 'event_investmentprofile_goalyears',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age,
  financial_goal,
  target_amount,
  goal_years
});

export const eventInvestmentProfileAnnualContribution = (language, name, age, financial_goal, target_amount, goal_years, initial_capital, annual_contribution) => ({
  eventName: 'event_investmentprofile_annualcontribution',
  screen_name: PATH.INVESTOR_PROFILE,
  language,
  name,
  age,
  financial_goal,
  target_amount,
  goal_years,
  initial_capital,
  annual_contribution
});

export const eventRiskAssesmentRiskProfile = (language, name) => ({
  eventName: 'event_riskassesment_riskprofile',
  screen_name: PATH.RISK_ASSESSMENT,
  language,
  name
});

export const eventRiskAssesmentNotSure = (language, name) => ({
  eventName: 'event_riskassesment_notsure',
  screen_name: PATH.RISK_ASSESSMENT,
  language,
  name
});

export const eventInvestmentPreferenceSharia = (language, value) => ({
  eventName: 'event_investmentpreferences_shariapreference',
  screen_name: PATH.INVESTMENT_PREFERENCE,
  language,
  value
});

export const eventInvestmentPreferenceCountry = (language, sharia_compliant, value) => ({
  eventName: 'event_investmentpreferences_countrypreference',
  screen_name: PATH.INVESTMENT_PREFERENCE,
  language,
  sharia_compliant,
  value
});

export const eventAssetAllocationLooksGood = (language, name) => ({
  eventName: 'event_assetallocation_looksgood',
  screen_name: PATH.ASSETS_ALLOCATION,
  language,
  name
});

export const eventAssetAllocationProductOverview = (language, name) => ({
  eventName: 'event_assetallocation_productoverview',
  screen_name: PATH.ASSETS_ALLOCATION,
  language,
  name
});

export const eventGoalSummaryCompleted = (language, name) => ({
  eventName: 'event_goalsummary_completed',
  screen_name: PATH.GOAL_SUMMARY,
  language,
  name
});